import React from 'react'
import creditImg1 from '../../Images/CreditImg/GeneralAgricultureLoan.jpg'
import creditImg2 from '../../Images/CreditImg/ByabasahikAgricultureLoan.jpg'
import creditImg3 from '../../Images/CreditImg/BusinessLoan.jpg'
import creditImg4 from '../../Images/CreditImg/HomeLoan.jpg'
import creditImg5 from '../../Images/CreditImg/LandLoan.jpg'
import creditImg6 from '../../Images/CreditImg/ForeignLoan.jpg'
import creditImg7 from '../../Images/CreditImg/EducationLoan.jpg'
import creditImg8 from '../../Images/CreditImg/VehicleLoan.jpg'
import creditImg9 from '../../Images/CreditImg/SamajikSanskarLoan.jpg'
import creditImg10 from '../../Images/CreditImg/LaghuUdyamLoan.jpg'
import creditImg11 from '../../Images/CreditImg/LaghuBittiyaLoan.jpg'
import creditImg12 from '../../Images/CreditImg/AayaArjanLoan.jpg'
import creditImg13 from '../../Images/CreditImg/AakasmikLoan.jpg'
import Logo from '../../Images/TopbarImg/Logo.png'
import Aos from 'aos'

const CreditAll = () => {

    Aos.init({
        duration: 1500,
        once: false,
        mirror: false,
        easing: 'ease-in-out-sine'
    })

    const creditList = [
        {
            id: '1',
            creditName: 'साधारण कृषि कर्जा',
            creditImg: creditImg1,
            path: '/service/loan-service/general-agriculture-loan'
        },
        {
            id: '2',
            creditName: 'व्यवसायिक कृषि ऋण',
            creditImg: creditImg2,
            path: '/service/loan-service/byabasahik-agriculture-loan'
        },
        {
            id: '3',
            creditName: 'व्यापारिक ऋण',
            creditImg: creditImg3,
            path: '/service/loan-service/business-loan'
        },
        {
            id: '4',
            creditName: 'घर निमार्ण ऋण',
            creditImg: creditImg4,
            path: '/service/loan-service/home-loan'
        },
        {
            id: '5',
            creditName: 'घर जग्गा खरिद ऋण',
            creditImg: creditImg5,
            path: '/service/loan-service/land-loan'
        },
        {
            id: '6',
            creditName: 'बैदेशिक रोजगार ऋण',
            creditImg: creditImg6,
            path: '/service/loan-service/foreign-loan'
        },
        {
            id: '7',
            creditName: 'शैक्षिक ऋण',
            creditImg: creditImg7,
            path: '/service/loan-service/education-loan'
        },
        {
            id: '8',
            creditName: 'सवारी साधन ऋण',
            creditImg: creditImg8,
            path: '/service/loan-service/vehicle-loan'
        },
        {
            id: '9',
            creditName: 'सामाजिक संस्कार ऋण',
            creditImg: creditImg9,
            path: '/service/loan-service/samajik-sanskar-loan'
        },
        {
            id: '10',
            creditName: 'लघु उद्यम ऋण',
            creditImg: creditImg10,
            path: '/service/loan-service/laghu-udyam-loan'
        },
        {
            id: '11',
            creditName: 'लघु वित्त आयआर्जन ऋण',
            creditImg: creditImg11,
            path: '/service/loan-service/laghu-bittiya-loan'
        },
        {
            id: '12',
            creditName: 'आयआर्जन ऋण ( बचत जमानत )',
            creditImg: creditImg12,
            path: '/service/loan-service/aaya-arjan-loan'
        },
        {
            id: '13',
            creditName: 'आकस्मिक ऋण',
            creditImg: creditImg13,
            path: '/service/loan-service/aakasmik-loan'
        },
    ]

    return (
        <>
            <div className='branches-div'>
                <div className='branches-body'>
                    <div className='card-container'>
                        {creditList.map((item, id) => {
                            return (
                                <a href={item.path}>
                                    <div className='card' key={id} data-aos='fade-right'>
                                        <div className='inner'>
                                            <div className='img-holder'>
                                                <img src={item.creditImg} alt='credit-Image' />
                                                <span
                                                    style={{
                                                        position: 'absolute',
                                                        left: '10px',
                                                        top: '10px',
                                                        color: 'white',
                                                        backgroundColor: 'rgb(0,166,80)',
                                                        padding: '5px',
                                                        borderRadius: '5px'
                                                    }}
                                                >
                                                    {item.creditName}
                                                </span>
                                                <img src={Logo} alt='logo'
                                                    style={{
                                                        position: 'absolute',
                                                        width: '30px',
                                                        height: '30px',
                                                        top: '10px',
                                                        right: '20px'
                                                    }} />
                                            </div>
                                            <div className='detail'>
                                                <h3>{item.creditName}</h3>
                                            </div>
                                        </div>
                                    </div>
                                </a>
                            )
                        })}
                    </div>
                </div>
            </div>
        </>
    )
}

export default CreditAll